import React, { createContext, useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import DesignPortfolio from "./components/Design/DesignPortfolio"
import PhotoGallery from "./components/Design/PhotoGallery"
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

export const AppContext = createContext();

function App() {
  const [load, upadateLoad] = useState(true);
  const [showGallery, setShowGallery] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <AppContext.Provider value={{ showGallery, setShowGallery }}>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/design" element={<DesignPortfolio />} />
          <Route path="/design/kitchen" element={<PhotoGallery />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
      </AppContext.Provider>
    </Router>
  );
}

export default App;
